import { Account } from '@radixdlt/radix-dapp-toolkit';
import { ActionFunctionArgs, LoaderFunctionArgs, json } from '@remix-run/cloudflare';
import { NavLink, Outlet, useFetcher, useLoaderData } from '@remix-run/react';
import { useState } from 'react';
import AccountSelector from '~/components/account-selector';
import { DataBlock } from "~/components/data-block";
import { IgnitionLiquidity } from '~/components/liquidity-ignition';
import PopoverAPY from '~/components/popover-apy';
import { fetchPrices } from '~/lib/astrolescent';
import { cache } from '~/lib/cache';
import { setDbFromContext } from '~/lib/db';
import { IGNITION_DEX_COMPONENT_ADDRESS, IGNITION_NFT_ADDRESS, IGNITION_NFT_ADDRESS_CAVIAR, IGNITION_NFT_ADDRESS_OCI, IGNITION_NFTS, POOL_TPES } from '~/lib/ignition';
import { getPairs } from '~/lib/models/pair';
import { ge7DayVolume } from '~/lib/models/statsPairDaily';
import { classNames, onIconError, prettyValue, XRD_RESOURCE_ADDRESS, getIconUrl, roundALR } from '~/lib/util';
import { fetchIgnitionIncentiveAmountLeft, ignitionPrice, useGatewayApi } from '~/rdt/gateway';

export async function loader({ context }: LoaderFunctionArgs) {
   setDbFromContext(context);

   const allPairs = await getPairs();
  const pairs = allPairs.filter((p) => p.Pair.dexAddress === IGNITION_DEX_COMPONENT_ADDRESS && p.Token.symbol !== 'hUSDC');
   const prices = await fetchPrices();
   
   const ignitionPrices = await cache('https://radix.defiplaza.net/cache/ignition-prices2', 1800, async () => {
      const prices = {};

      for (let pair of pairs) {
         const price = await ignitionPrice(pair.Token.address);

         prices[pair.Token.address] = price;
      }

      return prices;      
   })

   pairs.sort((a, b) => {
      // console.log(a.Pair.address, tvl[a.Pair.address]?.usdAmount, b.Pair.address, tvl[b.Pair.address]?.usdAmount);

      if (a.Pair.tvlUSD < b.Pair.tvlUSD) {
         return 1;
      } else if (a.Pair.tvlUSD > b.Pair.tvlUSD) {
         return -1;
      }

      return 0;
   });

   // calc volumes
   const volume24H = pairs.reduce(
     (total, p) => total + (p.Pair.baseVolume24H * (prices[p.Token.address]?.tokenPriceUSD || 0) + p.Pair.quoteVolume24H * prices[p.Pair.quoteToken].tokenPriceUSD) / 2,
      0
   );

   let volume7D = 0;
   for (let pair of pairs) {
      const [volume] = await ge7DayVolume(pair.Pair);

      volume7D += volume.usdVolume;
   }

   // calc tvl
   const xrdUSD = prices[XRD_RESOURCE_ADDRESS].tokenPriceUSD;
   const totalTVL = pairs.reduce((total, p) => {
      const base = p.Pair.baseTVL * ignitionPrices[p.Token.address] * xrdUSD || 0;
      const quote = p.Pair.quoteTVL * xrdUSD || 0;

      return total + base + quote;
   }, 0);

   // calc incentives left
   const amounts = await fetchIgnitionIncentiveAmountLeft();
   const incentiveTotalXRD = (102600935.5 + 102600935.5);
   const usdTotal = incentiveTotalXRD * prices[XRD_RESOURCE_ADDRESS].tokenPriceUSD;   
   const usdLeft = amounts.total * prices[XRD_RESOURCE_ADDRESS].tokenPriceUSD;   

   return json({
      pairs,
      totalTVL,
      volume24H,
      volume7D,
      usdLeft,
      usdTotal,
      amounts,
      incentiveTotalXRD
   });
}

export default function Ignition() {
   const { pairs, totalTVL, volume24H, volume7D, usdLeft, usdTotal, amounts, incentiveTotalXRD } = useLoaderData<typeof loader>();
   const fetcher = useFetcher<typeof action>();

   const [account, setAccount] = useState<string>('');

   function onAccount(account: Account) {
      setAccount(account.address);

      fetcher.submit({ account: account.address }, { method: 'POST' });
   }

   return (
     <div className="mx-4 mb-8 xl:container xl:mx-auto">
       <div className="mb-8">
         <h1 className="py-4 text-left text-3xl font-bold lg:py-8 lg:text-4xl">Stay CALM and Ignite your Liquidity 🚀</h1>
         {/* <h2 className="px-8 text-left text-xl font-medium">Lock your liquidity and receive an airdrop of up to 20% now</h2> */}

         {/* <div className="mt-4 grid grid-cols-2 gap-4">
           <div className="space-y-4 rounded-xl bg-white p-8 text-black lg:rounded-2xl">
             <p className="text-xl">What is Project Ignition?</p>
             <p>
               Project Ignition is the Radix liquidity incentive program where you receive up to 20% in XRD when you lock liquidity for 9 to 12 months, while your Impermanent Loss risk is further
               minimized.
             </p>
             <p>
               <a href="https://defiplaza.net/blog/keep-calm-and-ignite-your-liquidity/" target="_blank" className="underline">
                 Learn more
               </a>
               .
             </p>
           </div>

           <div className="space-y-4 rounded-xl bg-white p-8 text-black lg:rounded-2xl">
             <p className="text-xl">Useful links</p>
             <ul className="list-disc">
               <li>
                 <a href="https://www.slideshare.net/slideshows/why-defiplaza-is-your-best-bet-for-radixs-project-ignition/266716078" target="_blank">
                   Why DefiPlaza is your best bet for Radix's Project Ignition
                 </a>
               </li>
               <li>
                 <a href="https://defiplaza.net/blog/keep-calm-and-ignite-your-liquidity/" target="_blank">
                   Step-by-step guide to bridge liquidity
                 </a>
               </li>

               <li>
                 <a href="http://www.radixdlt.com/project-ignition-details" target="_blank">
                   Project Ignition Terms & Conditions
                 </a>
               </li>
             </ul>
           </div>
         </div> */}
       </div>

       {/* <h2 className="text-2xl font-medium text-left px-8 text-white">Add Locked Liquidity and receive up to 20% airdrop</h2> */}

       
       <h2 className="mt-8 text-left text-2xl font-medium">My Project Ignition Liquidity</h2>
       <section className="mt-4 space-y-4">
         <AccountSelector mode="dark" onAccount={onAccount}></AccountSelector>

         <IgnitionLiquidity pairs={fetcher.data?.myPairs || []} account={account} />
       </section>

       <dl className="lg:items-top mt-8 mb-4 flex flex-col space-y-4 lg:mb-8 lg:flex-row lg:space-x-4 lg:space-y-0">
         <DataBlock title="Total Value Locked" data={`$${prettyValue(totalTVL)}`} />
         <DataBlock title="Incentives Available" data={`0%`} />
         <DataBlock title="24H Volume" data={`$${prettyValue(volume24H)}`} />
         <DataBlock title="7D Volume" data={`$${prettyValue(volume7D)}`} />
       </dl>


       <section className="items-top mt-4 flex space-x-4">
         <div className="grow">
           <div className="dark:bg-background-900 space-y-4 rounded-xl bg-white p-8 text-white lg:rounded-2xl">
             <table className="min-w-full divide-y divide-gray-300">
               <thead className="dark:text-primary-100 text-primary-800">
                 <tr>
                   <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold sm:pl-0">
                     Pair
                   </th>
                   <th scope="col" className="hidden px-3 py-3.5 pr-1 text-left text-sm font-semibold sm:table-cell">
                     TVL
                   </th>
                   <th scope="col" className="hidden px-3 py-3.5 pl-1 text-left text-sm font-semibold sm:table-cell"></th>
                   <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold lg:table-cell">
                     <PopoverAPY title="7D ALR" timespan="This ALR is based on the data of the last seven days." />
                   </th>
                   <th scope="col" className="hidden px-3 py-3.5 text-left text-sm font-semibold lg:table-cell">
                     <PopoverAPY title="ALR" timespan="This ALR is based on the data since the creation of the pair." />
                   </th>
                   <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0"></th>
                 </tr>
               </thead>
               <tbody className="divide-primary-300 divide-y">
                 {pairs.map((pair) => {

                   return (
                     <tr key={pair.Token.address} className={classNames("dark:hover:bg-background-900 hover:bg-neutral-200")}>
                       <td className="w-full max-w-0 py-4 pl-4 pr-3 font-bold sm:w-auto sm:max-w-none sm:pl-0">
                         <div className="flex items-center">
                           <div className="relative h-8 w-12">
                             <img className="absolute left-4 top-0 h-8 w-8 shrink-0 rounded-full bg-white" src={getIconUrl(pair.quoteToken.iconUrl)} alt="" />
                             <img className="absolute left-0 top-0 h-8 w-8 shrink-0 rounded-full bg-white" src={getIconUrl(pair.Token.iconUrl)} onError={(evt) => onIconError(evt)} alt="" />
                           </div>
                           <div className="dark:taxt-white ml-4 text-black">
                             {pair.Token.symbol} / {pair.quoteToken.symbol}
                           </div>
                         </div>
                       </td>
                       <td className="dark:dark:text-primary-200 hidden px-3 py-4 pr-1 text-sm font-medium text-black sm:table-cell">
                         <p className="flex space-x-2">
                           <img className="h-4 w-4 shrink-0 rounded-full bg-white" src={getIconUrl(pair.Token.iconUrl)} onError={(evt) => onIconError(evt)} alt="" />
                           <span>
                             {prettyValue(pair.Pair.baseTVL || 0)} {pair.Token.symbol}
                           </span>
                         </p>
                         <p className="flex space-x-2">
                           <img className="h-4 w-4 shrink-0 rounded-full bg-white" src={getIconUrl(pair.quoteToken.iconUrl)} alt="" />
                           <span>
                             {prettyValue(pair.Pair.quoteTVL || 0)} {pair.quoteToken.symbol}
                           </span>
                         </p>
                       </td>
                       <td className="dark:dark:text-primary-200 hidden px-3 py-4 pl-1 font-medium text-black sm:table-cell">{prettyValue(pair.Pair.tvlUSD || 0)} USD</td>
                       <td className="dark:dark:text-primary-200 hidden px-3 py-4 pr-1 text-sm font-medium text-black sm:table-cell">
                         <p className="flex space-x-2">
                           <img className="h-4 w-4 shrink-0 rounded-full bg-white" src={getIconUrl(pair.Token.iconUrl, 16)} onError={(evt) => onIconError(evt)} alt="" />
                           <span>{roundALR(pair.Pair.baseAPY7D)}%</span>
                         </p>
                         <p className="flex space-x-2">
                           <img className="h-4 w-4 shrink-0 rounded-full bg-white" src={getIconUrl(pair.quoteToken.iconUrl, 16)} alt="" />
                           <span>{roundALR(pair.Pair.quoteAPY7D)}%</span>
                         </p>
                       </td>
                       <td className="dark:dark:text-primary-200 hidden px-3 py-4 pr-1 text-sm font-medium text-black sm:table-cell">
                         <p className="flex space-x-2">
                           <img className="h-4 w-4 shrink-0 rounded-full bg-white" src={getIconUrl(pair.Token.iconUrl, 16)} onError={(evt) => onIconError(evt)} alt="" />
                           <span>{roundALR(pair.Pair.baseAPY)}%</span>
                         </p>
                         <p className="flex space-x-2">
                           <img className="h-4 w-4 shrink-0 rounded-full bg-white" src={getIconUrl(pair.quoteToken.iconUrl, 16)} alt="" />
                           <span>{roundALR(pair.Pair.quoteAPY)}%</span>
                         </p>
                       </td>
                       <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                         <NavLink to={`/ignition/${pair.Token.address}`} className={({ isActive }) => (isActive ? "btn-white-table" : "btn-primary-table")}>
                           {({ isActive, isPending }) => (
                             <>
                               {isActive ? (
                                 <>
                                   <svg className="h-4 w-4" viewBox="2 2 16 16" xmlns="http://www.w3.org/2000/svg">
                                     <path
                                       d="M10.986 5.456a.608.608 0 0 0-.827 0 .564.564 0 0 0 0 .809l3.233 3.16H5.29a.579.579 0 0 0-.584.572.58.58 0 0 0 .584.572h8.102l-3.233 3.16a.564.564 0 0 0 0 .81c.11.107.257.167.414.167.155 0 .302-.06.413-.168l4.072-3.982a.778.778 0 0 0 0-1.119l-4.072-3.98z"
                                       fill="currentColor"
                                       fillRule="nonzero"
                                     ></path>
                                   </svg>
                                 </>
                               ) : amounts[POOL_TPES[pair.Token.address]] < 500 ? (
                                 "Full"
                               ) : (
                                 "Add"
                               )}
                             </>
                           )}
                         </NavLink>
                       </td>
                     </tr>
                   );
                 })}
               </tbody>
             </table>
           </div>
         </div>

         <Outlet />
       </section>


     </div>
   );
}

export async function action({ context, request }: ActionFunctionArgs) {
   setDbFromContext(context);

   const { state } = useGatewayApi;

   const formData = await request.formData();
   const account = formData.get('account') as string;

   if (!account) {
      return json({
         error: 'No address provided',
         myPairs: [],
      });
   }

   try {
      // Fetch NFTs with faults and ids
      const response = await state.innerClient.entityNonFungiblesPage({
         stateEntityNonFungiblesPageRequest: {
            address: account,
            aggregation_level: "Vault",
            opt_ins: {
               non_fungible_include_nfids: true
            }
         }
      });

      let localIds = [];

      for (let item of response.items) {
        //  if (item.resource_address !== IGNITION_NFT_ADDRESS) {
        //     continue;
        //  }
        
        let dex = 'df';

        if(item.resource_address == IGNITION_NFT_ADDRESS) {
          dex = 'plaza';
        }
        else if(item.resource_address == IGNITION_NFT_ADDRESS_CAVIAR) {
          dex = 'caviar';
        }
        else if(item.resource_address == IGNITION_NFT_ADDRESS_OCI) {
          dex = 'oci';
        }
        else {
          continue;
        }

        for(let id of item.vaults.items[0].items) {
          localIds.push({
            dex,
            localId: id
          })
        }
      }
      

      console.log(localIds)

      // If no NFT
      if (!localIds.length) {
         console.log('no NFT');

         return json({
            myPairs: [],
         });
      }

      // const pairs = await getPairs();
      const entries = [];
      
      for (let localId of localIds) {
        

        try {
          const ignitionDataResponse = await fetch(`https://ignition.defiplaza.workers.dev/json/${localId.dex}/${localId.localId.replace('{', '').replace('}', '')}`);
          const ignitionData = await ignitionDataResponse.json();

          console.log(ignitionData);

            entries.push({
              ...ignitionData,
              localId
          })
        } catch(err) {
          console.log(`https://ignition.defiplaza.workers.dev/json/caviar/${localId.replace('{', '').replace('}', '')}`)
          console.log(err)
        }

         // fetch NFT data
        //  const nftResponse = await state.getNonFungibleData(IGNITION_NFT_ADDRESS, localId);

        //  console.log(nftResponse.data?.programmatic_json.fields);

        //  let component;
        //  let lockupUntil = new Date().getTime();
        //  let amount = 0;

        //  for (let field of nftResponse.data?.programmatic_json.fields) {
        //    if (field.field_name == 'user_resource_address') {
        //       component = pairs.find(c => c.Token.address == field.value);
        //       continue;
        //    }

        //      if (field.field_name == 'maturity_date') {
        //         lockupUntil =  field.value * 1000;
        //         continue;
        //      }
            
        //     if (field.field_name == 'user_contribution_amount') {
        //        amount = field.value;
        //        continue;
        //     }
        //  }

        //  entries.push({
        //     ...component,
        //     lockupUntil,
        //     amount,
        //     localId
        //  })
      }

    //  console.log(entries)

    const myPairs = [...entries.filter(e => e.postionId == 'plaza'), ...entries.filter(e => e.postionId !== 'plaza')]

      return json({ myPairs });
   }
   catch (err) {
    console.error(err)
      return json({ myPairs: [] });
   }
}
